import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/site/ProductCard";

export default function Products() {
  const [params, setParams] = useSearchParams();
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState(null);
  const category = params.get("category") || "";

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
  }, []);
  useEffect(() => {
    setProducts(null);
    api.get("/products", { params: category ? { category } : {} }).then((r) => setProducts(r.data));
  }, [category]);
  const catName = useMemo(() => Object.fromEntries(cats.map((c) => [c.id, c.name])), [cats]);

  const chip = (id, label) => (
    <button key={id || "all"} onClick={() => setParams(id ? { category: id } : {})} className={`rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${category === id ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white hover:border-slate-400"}`} data-testid={`category-filter-${id || "all"}`}>
      {label}
    </button>
  );

  return (
    <div className="container-x py-16">
      <p className="text-xs font-bold uppercase tracking-widest text-teal-700">Our products</p>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">Shop BMI SP GROUP</h1>
      <p className="mt-3 max-w-2xl text-slate-600">No job application needed. Pay securely online via Razorpay — Cash on Delivery is not available.</p>
      <div className="mt-8 flex flex-wrap gap-2">{chip("", "All")}{cats.map((c) => chip(c.id, c.name))}</div>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="product-grid">
        {products === null && <p className="text-sm text-slate-500">Loading…</p>}
        {products?.length === 0 && <p className="text-sm text-slate-500" data-testid="no-products">No products in this category yet.</p>}
        {products?.map((p) => <ProductCard key={p.id} product={p} categoryName={catName[p.category_id]} />)}
      </div>
    </div>
  );
}
